var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 217,
    height: 217,
    preserveAspectRatio: "xMidYMid",
    style: {
      margin: "auto",
      background: "#fff",
      display: "block",
      shapeRendering: "auto"
    },
    viewBox: "0 0 100 100"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.0265700483091786s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(20 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.9661835748792269s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(40 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.9057971014492753s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.8454106280193235s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(80 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.7850241545893719s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(100 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.7246376811594202s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.6642512077294686s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(140 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.6038647342995168s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(160 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.5434782608695652s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.48309178743961345s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(200 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.42270531400966177s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(220 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.3623188405797101s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.3019323671497584s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(260 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.24154589371980673s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(280 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.18115942028985504s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.12077294685990336s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(320 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.06038647342995168s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 48.5,
    y: 23.5,
    rx: 1.5,
    ry: 3.5,
    transform: "rotate(340 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    dur: "1.0869565217391304s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))));
};
export default SvgSpinner;